import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import jwtDecode from 'jwt-decode'

export default function Dashboard() { 
    const { t } = useTranslation()

    let token = jwtDecode(sessionStorage.getItem('jwt'))

    return (
        <>
            <Container className='cuerpo text-center'>
                <Row className="text-left custom-card-header">
                <h1>{t('signin.bienvenido')}</h1>
                <br/><br/><br/>
                    <Row className="text-center my-3">
                        <Col>
                            <Link to="/operator/input">
                                <i className="far fa-id-card custom-fas-big"></i>
                                <br/>
                                {t('menu.input')}
                            </Link>
                        </Col>
                        { token?.counter
                            ?
                                <Col>
                                    <Link to="/operator/counters">
                                        <i className="far fa-id-card custom-fas-big"></i>
                                        <br/>
                                        {t('menu.counter')}
                                    </Link>
                                </Col>
                            :
                                <></>
                        }
                    </Row>
                </Row>
            </Container>
        </>
    )
}